import Axios from "axios-observable";
import { map } from "rxjs/operators";

import { Observable } from "rxjs";
import langHelper from "@/locales/langHelper";
import { Speaker } from "@/entities/Speaker";
import { Speech } from "@/entities/Speech";
import { SpeechFilter } from "@/entities/SpeechFilter";
import { Role } from "@/entities/Role";

export class Services {

  private static readonly backendUrl = process.env.VUE_APP_BACKEND_URL;
  private static readonly project = process.env.VUE_APP_PROJECT;


  static getSpeakers(): Observable<Speaker[]> {
    return Axios.get<Speaker[]>(`${this.backendUrl}/${langHelper.getCurrentLang()}/${this.project}/speakers`)
      .pipe(map((data: any) => {
        let speakers = [];
        for (const s of data.data.speakers) {
          speakers.push(new Speaker(s, data.data.path));
        }
        return speakers;
      }));
  }

  static getSpeechFilters(): Observable<SpeechFilter> {
    return Axios.get<SpeechFilter>(`${this.backendUrl}/${langHelper.getCurrentLang()}/${this.project}/speechFilters`)
      .pipe(map((data: any) => {
        return new SpeechFilter(data.data);
      }));
  }

  static getSpeeches(): Observable<Speech[]> {
    return Axios.get<Speech[]>(`${this.backendUrl}/${langHelper.getCurrentLang()}/${this.project}/speeches`)
      .pipe(map((data: any) => {
        const speeches = [];
        for (const s of data.data.speeches) {
          speeches.push(new Speech(s, data.data.path));
        }
        speeches.sort(Speech.comparator);
        return speeches;
      }));
  }

  static getRoles(): Observable<any> {
    return Axios.get<any>(`${this.backendUrl}/${langHelper.getCurrentLang()}/${this.project}/roles`)
      .pipe(map((data: any) => {
        let roles = [];
        for (const r of data.data) {
          roles.push(new Role(r));
        }
        roles.sort(Role.comparator);
        return roles;
      }));
  }

}
